import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AdminService } from 'app/modules/admin/services/admin.service';
import { Quota } from 'app/modules/domain/models/quota';

@Component({
  selector: 'app-edit-user-quota',
  templateUrl: './edit-user-quota.component.html',
  styleUrls: ['./edit-user-quota.component.scss']
})
export class EditUserQuotaComponent implements OnInit {
  public editQuotaForm: FormGroup;
  public availableQuota: number;
  private availableCompanyQuota: number;

  constructor(private dialogRef: MdDialogRef<EditUserQuotaComponent>,
              private formBuilder: FormBuilder,
              private adminService: AdminService,
              @Inject(MD_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.editQuotaForm = this.formBuilder.group({
      userQuota: [this.data.userQuota, [Validators.required, Validators.min(0)]]
    });

    this.adminService.getQuotaForCompanyUsers(this.data.companyId).subscribe((quotas: Quota[]) => {
      const companyQuota = quotas.find(q => q.userId === q.companyId);

      if (companyQuota && companyQuota.limit) {
        const allocatedQuota = quotas.filter(q => q.userId !== q.companyId).reduce((prev, curr) => prev + curr.limit, 0);
        this.availableCompanyQuota = companyQuota.limit - allocatedQuota;
        this.availableQuota = this.availableCompanyQuota;

        this.editQuotaForm = this.formBuilder.group({
          userQuota: [this.data.userQuota, [Validators.required, Validators.min(0), Validators.max(this.availableCompanyQuota)]]
        });
      }
    });
  }

  userQuotaUpdated() {
    this.availableQuota = this.availableCompanyQuota + (this.data.userQuota - this.editQuotaForm.value.userQuota);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick(quotaData) {
    this.dialogRef.close(quotaData);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/myaccount/components/edit-user-quota/edit-user-quota.component.ts